export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/78489dd5fe22b2b724f99f5861a7cee7.svg";